import { api } from './client'

/**
 * Beta feedback from inside Report Center (spec 123).
 *
 * The submitter's identity is NOT sent from here — cb-api takes tenant and user
 * from the verified token. The client sends only what the user typed plus the
 * context they were in, because a client that could name its own tenant could
 * file feedback against another firm.
 */
const reportFeedbackService = {
  /**
   * File one piece of feedback.
   *
   * Returns `{ ok: true, id }` or `{ ok: false, error }` — it never throws, so a
   * failed submit shows a message in the form rather than breaking the report
   * page the user is standing on.
   */
  async submit(payload) {
    try {
      const { data } = await api.post('/reports/feedback', payload)
      return { ok: true, id: data?.data?.id || null }
    } catch (err) {
      const status = err?.response?.status
      // 429 carries a real, actionable sentence from the server; everything else
      // gets a generic one, because server error text is not written for users.
      const error = status === 429
        ? (err?.response?.data?.error || 'Too much feedback filed today.')
        : status === 400
          ? (err?.response?.data?.error || 'That could not be sent.')
          : 'That could not be sent. Please try again.'
      return { ok: false, error }
    }
  },

  /** What this user has filed before. Never throws; degrades to an empty list. */
  async mine() {
    try {
      const { data } = await api.get('/reports/feedback/mine')
      return Array.isArray(data?.data) ? data.data : []
    } catch {
      return []
    }
  },
}

export default reportFeedbackService
